import cx from 'classnames'
import { Modal } from 'antd'

import { CloseButton } from 'components/Buttons/CloseButton'
import Styles from './TypeConfirmationModal.module.scss'

interface Props {
  visible: boolean
  onConvert: () => void
  setVisible: (visible: boolean) => void
}

const TypeConfirmationModal = ({ visible, onConvert, setVisible }: Props) => {
  return (
    <div className={Styles.container}>
      <Modal
        visible={visible}
        onCancel={() => setVisible(false)}
        wrapClassName={cx(Styles.container, 'ignore-click-outside')}
        footer={null}
        closable={false}
        width={560}
      >
        <div className={Styles.header}>
          <div className={Styles.headerTitle}>Are you sure you want to convert this property type?</div>
          <CloseButton onClick={() => setVisible(false)} />
        </div>
        <div className={Styles.modalDescription}>
          <p>Converting this property type may clear the values from every instance this property is used.</p>
          <p>If the conversion causes a problem, you can press undo afterwards.</p>
        </div>
        <div className={Styles.modalButtons}>
          <button className={Styles.cancelButton} onClick={() => setVisible(false)} type="button">
            Cancel
          </button>
          <button className={Styles.convertButton} onClick={onConvert} type="button">
            Convert
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default TypeConfirmationModal
